import React from 'react';
import PropTypes from 'prop-types';
import { MetadataPropTypesShape } from '@Components/Results/MetadataPropTypes';
import ResultsList from '@Components/Results/ResultsList';
import SimpleSpinner from '@Components/Results/utils/SimpleSpinner';

/**
 * Wraps ResultsList with its loading overlay spinner.
 * Extracts the results-list-with-spinner pattern from ResultsPage.
 */
export default function ResultsListWithLoader({
  metadata,
  context,
  results,
  gridView,
  searchType,
  originalSearchType,
  size,
  currentPage,
  totalPages,
  resultsLoading,
}) {
  return (
    <div className="rx-list-wrapper u-els-margin-top-1o2">
      <ResultsList
        metadata={metadata}
        context={context}
        results={results}
        gridView={gridView}
        searchType={searchType}
        originalSearchType={originalSearchType}
        size={size}
        currentPage={currentPage}
        totalPages={totalPages}
      />
      {resultsLoading && (
        <div className="item-placeholder z-index-100">
          <SimpleSpinner className="e2e-results-spinner rx-loader--container__relative" />
        </div>
      )}
    </div>
  );
}

ResultsListWithLoader.propTypes = {
  metadata: MetadataPropTypesShape,
  context: PropTypes.string.isRequired,
  results: PropTypes.array.isRequired,
  gridView: PropTypes.bool,
  searchType: PropTypes.string,
  originalSearchType: PropTypes.string,
  size: PropTypes.number,
  currentPage: PropTypes.number,
  totalPages: PropTypes.number,
  resultsLoading: PropTypes.bool,
};
